

(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', '$state','AuditsService', 'ParseLinks', 'pagingParams', 'Context'];

    function AuditsController ($filter, $state, AuditsService, ParseLinks, pagingParams, Context) {
        var vm = this;

        vm.domains = [];
        vm.domain = [];
        vm.predicates = pagingParams.predicates;
        vm.charToSearch = pagingParams.search;
        vm.fromDate = pagingParams.fromDate;
        vm.toDate = pagingParams.toDate;
        vm.filter = pagingParams.filter;
        vm.loadAllToExport = loadAllToExport;
        vm.onChangeDate = onChangeDate;
        vm.exportTable = exportTable;
        vm.transition = transition;
        vm.loadPage = loadPage;
        vm.loadAll = loadAll;
        vm.currentState = "audits";
        vm.totalItems = null;
        vm.audits = null;
        vm.links = null;
        vm.size = 20;
        vm.page = pagingParams.page;
        vm.onChangeDate();

        Context.query(function (result) {
            var all = {
                id: -1,
                domainName: "All"
            };
            vm.domains = result;
            vm.domains.unshift(all);
        });

        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder !== null && retrievedOrder !== "null") {
            vm.predicates = JSON.parse(retrievedOrder);
        }

        function onChangeDate() {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);
            var domain = vm.domain.id == null || vm.domain.id == undefined ? -1 : vm.domain.id;

            AuditsService.query({
                page: vm.page - 1,
                size: vm.size,
                fromDate: fromDate,
                toDate: toDate,
                domain: domain,
                query: vm.charToSearch,
                sort: sort()
            }, function (result, headers) {
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }

        function loadAll () {
            vm.page = 1;
            vm.onChangeDate();
        }

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc'));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);
            var domain = vm.domain.id == null || vm.domain.id == undefined ? -1 : vm.domain.id;
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: sort(),
                predicates: vm.predicates,
                search: vm.charToSearch,
                fromDate: fromDate,
                toDate: toDate,
                domain: domain
            }, {notify: notify, location: "replace"});
        }

        vm.search = function () {
            vm.page = 1;
            vm.onChangeDate();
            vm.transition(false);
        };

        function loadAllToExport(){
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);
            var ch = vm.charToSearch;
            var domain = vm.domain.id == null || vm.domain.id == undefined ? -1 : vm.domain.id;

            var body = {
                page: 0,
                size: 1000,
                fromDate: fromDate,
                toDate: toDate,
                query: ch,
                domain : domain
            };
            AuditsService.query(body, onSuccess, onError);
            function onSuccess(result) {vm.audits = result;}
            function onError() {}
        }

        function exportTable(type) {
            if (type == 'pdf') {
                $('#tableToExport').tableExport({
                    type: 'pdf',
                    pdfFontSize: '7',
                    escape: 'false',
                    size: {0: 100, 1: 80, 2: 150, 3: 100},
                    tableName: 'Audits'
                });
            } else if (type != null) {
                $('#tableToExport').tableExport({type: type, escape: 'false', tableName: 'Audits'});
            }
            vm.onChangeDate();
        }
    }
})();

